import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { FdFieldConfigs } from 'src/app/shared/fd-form-components/fd-form-components.module';
import { TransformType } from '../../../shared/fd-form-components/fd-input/fd-input.component';
import { cpfCnpjMask } from 'src/app/shared/masks/document-masks';
import { MatDialogRef} from '@angular/material/dialog';
import { LoadingService } from '../../../shared/service/loading.service';
import { ConfigurationPfacService } from '../../services/configuration-pfac.service';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Messages } from '../../../shared/messages/messages';
import { ErrorService } from '../../../shared/service/error.service';
import { DialogService } from '../../../shared/service/dialog.service';
import { CreatePfacModel } from '../../models/configuration-pfac.models';

@Component({
  selector: 'app-add-pfac',
  templateUrl: './add-pfac.component.html',
  styleUrl: './add-pfac.component.scss',
  standalone: false
})
export class AddPfacComponent implements OnInit {

  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  createPfacModel: CreatePfacModel = new CreatePfacModel();

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AddPfacComponent>,
    public loadingService: LoadingService,
    private configurationPfacService: ConfigurationPfacService,
    private errorService: ErrorService,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    this.formGroup = this.createFormGroup();
    this.fields = this.createFields();
  }

  protected createFormGroup() {
    return this.formBuilder.group({
      cnpj: ['', Validators.required],
      name: ['', Validators.required],
    });
  }

  createFields(): FdFieldConfigs {
      return {
        cnpj: {
          label: 'CNPJ',
          controlName: 'cnpj',
          maskCharsReplace: /[.\/ -]/g,
          transform: TransformType.UPPERCASE,
          mask: cpfCnpjMask,          
          messages: {
            required: 'Informe o CNPJ',
            invalidCnpj: 'CNPJ inválido'
          }
        },
        name: {
          label: 'Nome',
          controlName: 'name',
          maxLength: 200,
          messages: {
            required: 'Informe o nome'
          }
        },
      };
  }

  save() {
    if (!this.formGroup.valid) {
      return;
    }
    this.createPfacModel.cnpj =  this.formGroup.value.cnpj || null;
    this.createPfacModel.name =  this.formGroup.value.name || null;
    this.loadingService.show();
    this.configurationPfacService.save(this.createPfacModel)
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe(() => {
        this.dialogService.openDialog(Messages.EDIT_SAVE_SUCCESS, () => this.close(true));
      }, (err: HttpErrorResponse) => this.errorService.handleXHRError(err, Messages.EDIT_SAVE_ERROR, () => this.close()));

    
  }

  close(updated: boolean = false) {
    this.dialogRef.close(updated);
  }

}
